/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getPasscodeAndSsnDetails} from '../api'

 export const useQueryGetPasscodeAndSsnDetails = createReactQueryHook('getPasscodeAndSsnDetails', getPasscodeAndSsnDetails)
